import { render, staticRenderFns } from "./bet-history.vue?vue&type=template&id=7e489dbe&scoped=true"
import script from "./bet-history.vue?vue&type=script&lang=js"
export * from "./bet-history.vue?vue&type=script&lang=js"
import style0 from "./bet-history.vue?vue&type=style&index=0&id=7e489dbe&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e489dbe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e489dbe')) {
      api.createRecord('7e489dbe', component.options)
    } else {
      api.reload('7e489dbe', component.options)
    }
    module.hot.accept("./bet-history.vue?vue&type=template&id=7e489dbe&scoped=true", function () {
      api.rerender('7e489dbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tables/bet-history.vue"
export default component.exports